import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormSwiftAPI from 'formswift-api';
import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import { PrimaryButton } from 'DesignSystem/Buttons';
import { HeadingF } from 'DesignSystem/Typography';
import { Form } from 'informed';
import { Alert, AlertTypes } from 'DesignSystem/Notifications';
import { EmailInput, PasswordInput } from 'DesignSystem/TextInputs';
import Link from 'DesignSystem/Link';

const NewAccountPanel = (props) => {
  const [email, setEmail] = useState(undefined);
  const [password, setPassword] = useState(undefined);
  const [formError, setFormError] = useState(null);

  const updateTemplateOwner = async (documentType) => {
    const formswiftAPIClient = new FormSwiftAPIClient(window.API_URL);
    const payload = {
      creator_user_id: window.COOKIE.get('userid'),
      creator_user_token: window.COOKIE.get('userToken'),
    };
    try {
      await formswiftAPIClient.request(
        'POST',
        `/custom-template/${documentType}`,
        payload,
      );
      return true;
    } catch (e) {
      setFormError(e.message);
      throw e;
    }
  };


  const createNewAccount = async () => {
    const registrationPayload = {
      email,
      password,
      confirm_password: password,
      promo_code: 'TEMPLATE',
    };
    const registrationResult = await window.FormSwiftAPI.register(registrationPayload);
    if (!registrationResult) {
      setFormError(window.FormSwiftAPI.errorMessage);
      return false;
    }
    return registrationResult;
  };

  const onSubmit = async () => {
    const { documentType } = props;
    try {
      const registrationResult = await createNewAccount();
      await updateTemplateOwner(documentType);
      FormSwiftAPI.saveTrackingAndRedirect(
        registrationResult.id,
        `/self-serve-builder?documentType=${documentType}`,
      );
      return true;
    } catch (e) {
      return false;
    }
  };

  return (
    <div className="new-account-panel">
      <HeadingF>Create a Free Account to Add Fillable Fields</HeadingF>
      <Form onSubmit={onSubmit}>
        <EmailInput
          className="new-account-form-input"
          id="zeroStateModalRegistrationFormEmail"
          label="Email:"
          placeholder="maryjane@email.com"
          onChange={e => setEmail(e.target.value)}
          value={email}
        />
        <PasswordInput
          className="new-account-form-input"
          id="zeroStateModalRegistrationFormPassword"
          label="Password:"
          placeholder="Combine letters, numbers, and symbols"
          onChange={e => setPassword(e.target.value)}
          value={password}
        />
        {formError &&
          <Alert type={AlertTypes.Error}>
            An error occurred while creating your account.
            If you already have an account please <Link href="/sign-in?redirect_url=self-serve-builder">sign in</Link>
          </Alert>
        }
        <PrimaryButton
          className="create-account-cta"
          type="submit"
        >
          Create Account &amp; Start Document
        </PrimaryButton>
      </Form>
      <p className="terms-of-service-info">
        Your e-mail will not be shared with anyone. We will not send you
        junk mail or newsletters. By continuing, you confirm that you have
        read and consent to our <Link href="/terms.php">Terms of Use</Link> and <Link href="/privacy">Privacy Policy</Link>
      </p>
    </div>
  );
};

NewAccountPanel.propTypes = {
  documentType: PropTypes.string.isRequired,
};

export default NewAccountPanel;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/ZeroStateModal/ZeroStateModalNewAccountBody/NewAccountPanel.jsx